import { render, staticRenderFns } from "./CitizenApplicantForm.vue?vue&type=template&id=dd978c32&"
import script from "./CitizenApplicantForm.vue?vue&type=script&lang=js&"
export * from "./CitizenApplicantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports